export type DeliveryPlatform = 'deliveroo' | 'ubereats'

export const DELIVERY_PLATFORMS: DeliveryPlatform[] = ['ubereats', 'deliveroo']

export const DELIVERY_PLATFORM_LABELS: Record<DeliveryPlatform, string> = {
  deliveroo: 'Deliveroo',
  ubereats: 'Uber Eats'
}

/** Back-office page where the merchant invites users. */
export const DELIVERY_PLATFORM_USERS_URLS: Record<DeliveryPlatform, string> = {
  deliveroo: 'https://partner-hub.deliveroo.com/admin/users',
  ubereats: 'https://merchants.ubereats.com/manager/users'
}

/** Days during which a review can still be answered on the platform. */
export const REPLY_DEADLINE_DAYS: Record<DeliveryPlatform, number> = { ubereats: 14, deliveroo: 60 }

export const NEGATIVE_RATING_THRESHOLD = 2

export type DeliveryConnectionStatus =
  | 'not_started'
  | 'awaiting_invitation'
  | 'action_required'
  | 'connected'
  | 'access_lost'
  | 'paused'

export interface DeliveryExternalStore {
  externalStoreId: string
  name: string
  address: string | null
  organizationName: string | null
  accessRevoked: boolean
  storeId: number | null
}

export interface DeliveryConnection {
  platform: DeliveryPlatform
  status: DeliveryConnectionStatus
  invitationEmail: string | null
  error: string | null
  invitationReceivedAt: string | null
  connectedAt: string | null
  accessSyncedAt: string | null
  stores: DeliveryExternalStore[]
}

export interface DeliveryStoreMapping {
  external_store_id: string
  store_id: number | null
}

export interface DeliveryReviewOrder {
  orderUuid: string
  platformSlug: DeliveryPlatform
  orderTotal: number | null
  currencyCode: string | null
  deliveredAt: string | null
  items: { name: string; quantity: number }[] | null
}

export interface DeliveryReview {
  id: number
  date: string
  text: string | null
  rating: number | null
  name: string | null
  ownerResponseText: string | null
  ownerResponseStatus: string | null
  repliedAt: string | null
  order: DeliveryReviewOrder | null
  store: { id: number; name: string } | null
  reviewManager: { slug: DeliveryPlatform; name: string } | null
}

export interface DeliveryReviewFilters {
  platform: DeliveryPlatform | null
  storeId: number | null
  rating: number | null
  onlyUnanswered: boolean
}

export interface Paginated<T> {
  data: T[]
  meta: { current_page: number; last_page: number; total: number }
}
